import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import { logoUrl } from "../hooks/useCloudinaryImages";

export default function NavBar() {
  return (
    <Navbar expand="lg">
      <div className="container">
        <Navbar.Brand as={NavLink} to="/">
          <img src={logoUrl()} alt="Santiago Aquino" className="navbar-logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{ border: "none" }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-end flex-grow-1">
            <Nav.Link as={NavLink} to="/beauty">
              Beauty
            </Nav.Link>
            <Nav.Link as={NavLink} to="/retratos">
              Retratos
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about">
              About
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
